/*
 * Copyright 2023 Thoughtworks, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const IDENTIFIER_FORMAT_HELP_MESSAGE = "No spaces. Only letters, numbers, hyphens, underscores, and periods. Max 255 chars.";
export const DESTINATION_DIR_HELP_MESSAGE = "Specify a different path to clone/checkout this repository. Must be a relative path within the pipeline’s working directory. Defaults to the root of the pipeline's working directory.";
export const DENYLIST_HELP_MESSAGE = "Enter the paths to be excluded when deciding whether to trigger a pipeline based on a change. Separate multiple entries with a comma.";
